import { IComments } from '@/models/Comments'
import { getHostName } from '@ghl/clientportal-core'
import { Router } from 'vue-router'

export async function handleShareComment(
  parentId: string,
  comment: IComments,
  router: Router
): Promise<void> {
  const commentLink = `https://${getHostName()}${
    router.currentRoute.value.fullPath.split('?')[0]
  }?commentId=${comment._id}&parentId=${parentId}`
  await navigator.clipboard.writeText(commentLink)
}

export function getShareableCommentLink(
  parentId: string,
  comment: IComments,
  router: Router
): string {
  return `https://${getHostName()}${
    router.currentRoute.value.fullPath.split('?')[0]
  }?commentId=${comment._id}&parentId=${parentId}`
}
